import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import PMultiSelect from "primevue/multiselect";

export default /*#__PURE__*/_defineComponent({
  __name: 'Filter',
  props: {
  allWord: {
    type: String,
    default: null,
  },
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: Array,
    default: null,
  },
  placeholder: {
    type: String,
    default: "",
  },
},
  emits: ["filter", "update:modelValue"],
  setup(__props, { emit: emits }) {




const applyFilter = ({ value }: any) => {
  emits("update:modelValue", value);
  emits("filter", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PMultiSelect), {
    "model-value": __props.modelValue,
    options: __props.options,
    "option-label": "name",
    "option-value": "id",
    "data-key": "id",
    placeholder: __props.placeholder,
    class: "flex-grow lg:max-w-sm",
    onChange: applyFilter,
    showClear: ""
  }, _createSlots({ _: 2 }, [
    (__props.modelValue?.length === __props.options?.length && __props.allWord)
      ? {
          name: "value",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.allWord), 1)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["model-value", "options", "placeholder"]))
}
}

})